import { useContext } from "react";
import { Helmet } from "react-helmet";
import { Box, Container, Typography, Grid, Paper } from "@mui/material";
import { LanguageContext } from "../context/LanguageContext";

export default function AboutUs() {
  const { translate } = useContext(LanguageContext);

  return (
    <>
      <Helmet>
        <title>{translate("AboutPageTitle")}</title>
        <meta name="description" content={translate("AboutPageMeta")} />
      </Helmet>

      {/* Section Héros */}
      {/* <Box sx={{ py: 8, backgroundColor: "#f9f9fc" }}> */}
      <Box sx={{ py: 8, bgcolor: "background.default", color: "text.primary" }}>
        <Container maxWidth="md">
          <Typography variant="h3" fontWeight={700} align="center" gutterBottom>
            {translate("AboutHeroTitle")}
          </Typography>
          <Typography variant="h6" color="text.secondary" align="center">
            {translate("AboutHeroSubtitle")}
          </Typography>
        </Container>
      </Box>

      {/* Section Modèle Économique */}
      <Box sx={{ py: 6 }}>
        <Container maxWidth="lg">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
            {translate("AboutModelTitle")}
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2, justifyContent: "center" }}>
            <Grid item xs={12} md={6}>
              {/* <Paper sx={{ p: 4, borderRadius: 2 }}> */}
              <Paper
                sx={{
                  p: 4,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  border: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  {translate("FreePlanTitle")}
                </Typography>
                <Typography gutterBottom>
                  • {translate("FreePlanFeature1")}
                </Typography>
                <Typography gutterBottom>
                  • {translate("FreePlanFeature2")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              {/* <Paper sx={{ p: 4, borderRadius: 2 }}> */}
              <Paper
                sx={{
                  p: 4,
                  borderRadius: 2,
                  bgcolor: "background.paper",
                  border: "1px solid",
                  borderColor: "divider",
                }}
              >
                <Typography variant="h5" fontWeight={600} gutterBottom>
                  {translate("PremiumPlanTitle")}
                </Typography>
                <Typography gutterBottom>
                  • {translate("PremiumPlanFeature1")}
                </Typography>
                <Typography gutterBottom>
                  • {translate("PremiumPlanFeature2")}
                </Typography>
                <Typography gutterBottom>
                  • {translate("PremiumPlanFeature3")}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Section Pourquoi nous choisir */}
      {/* <Box sx={{ py: 6, backgroundColor: "#fafafb" }}> */}
      <Box sx={{ py: 6, bgcolor: "background.default" }}>
        <Container maxWidth="md">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
            {translate("WhyChooseTitle")}
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2, justifyContent: "center" }}>
            {[1, 2, 3].map((i) => (
              <Grid key={i} item xs={12} md={4}>
                {/* <Paper sx={{ p: 3, textAlign: "center", borderRadius: 2 }}> */}
                <Paper
                  sx={{
                    p: 3,
                    textAlign: "center",
                    borderRadius: 2,
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                >
                  <Typography variant="h6" fontWeight={600} gutterBottom>
                    {translate(`WhyChooseFeature${i}Title`)}
                  </Typography>
                  <Typography color="text.secondary">
                    {translate(`WhyChooseFeature${i}Desc`)}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
